import Menu from '@mui/material/Menu';
import { styled as materialStyled } from '@mui/material/styles';
import { theme } from '../../theme/theme';

export const CustomMenu = materialStyled(Menu)(() => ({
  marginTop: '50px',
  '& .MuiList-root': {
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: '8px',
    boxShadow: `0px 0px 24px 0px ${theme.palette.shades.shadow}`,
  },
}));
